/**
 * The deployment vocabulary the whole platform tags telemetry with.
 *
 * These four values are NOT free-form: they must match, byte for byte, what the .NET hosts send as
 * `Sentry:Environment` (`deploy/appsettings.Production.json` → the `SENTRY_ENVIRONMENT` pipeline token,
 * one value per `cheqme-env-<env>` variable group) and what `infra/main.bicep` / `infra/stage2.bicep`
 * accept as their `environment` tag. Sentry's `environment` filter is an exact string match, so a SPA
 * event tagged `prod` or `int01` would silently drop out of the same saved search that finds the server
 * events from the very same request.
 *
 *   development → the developer's own machine (no deployment)
 *   internal    → int01
 *   preview     → prev01
 *   production  → prod01
 */
export enum EnvironmentTypes {
  Development = "development",
  Internal = "internal",
  Preview = "preview",
  Production = "production"
}
